export default __webpack_public_path__ + "static/media/icon-empty-file-format.15dc9372.svg";